import React from 'react';
import { NewHero } from './components/NewHero';
import { SocialProof } from './components/SocialProof';
import { NewProblem } from './components/NewProblem';
import { AnimatedStats } from './components/AnimatedStats';
import { Chapters } from './components/Chapters';
import { Villains } from './components/Villains';
import { Allies } from './components/Allies';
import { Timeline } from './components/Timeline';
import { NewTestimonials } from './components/NewTestimonials';
import { Includes } from './components/Includes';
import { EbookIndex } from './components/EbookIndex';
import { NewOffer } from './components/NewOffer';
import { NewFAQ } from './components/NewFAQ';
import { NewFinalCTA } from './components/NewFinalCTA';
import { Footer } from './components/Footer';
import { CheckoutModal } from './components/CheckoutModal';
import { SocialToast } from './components/SocialToast';
import { UrgencyBar } from './components/UrgencyBar';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden font-sans bg-forest selection:bg-peach/30" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <NewHero data-id="element-2" />
      <SocialProof data-id="element-3" />
      <NewProblem data-id="element-4" />
      <AnimatedStats data-id="element-5" />
      <Chapters data-id="element-6" />
      <Villains data-id="element-7" />
      <Allies data-id="element-8" />
      <Timeline data-id="element-9" />
      <NewTestimonials data-id="element-10" />
      <Includes data-id="element-11" />
      <EbookIndex data-id="element-12" />
      <NewOffer data-id="element-13" />
      <NewFAQ data-id="element-14" />
      <NewFinalCTA data-id="element-15" />
      <Footer data-id="element-16" />
      <CheckoutModal data-id="element-17" />
      <SocialToast data-id="element-18" />
    </div>;
}